module.exports = __webpack_public_path__ + "static/media/background_mobile@2x.f3400668.png";